var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.438 2.563h-.605v-1.21A.604.604 0 0012.23.75h-.604a.604.604 0 00-.604.604v1.208H4.979V1.355A.604.604 0 004.375.75h-.604a.604.604 0 00-.604.604v1.208h-.604c-1 0-1.813.814-1.813 1.813v9.063c0 .999.813 1.812 1.813 1.812h10.874c1 0 1.813-.813 1.813-1.813V4.376c0-1-.813-1.813-1.813-1.813zm.604 10.874a.605.605 0 01-.604.605H2.562a.605.605 0 01-.604-.604V6.816h12.084v6.622z"}));
}

Calendar.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Calendar;

Calendar.default = Calendar;
